/** Чекбокс анкеты CRM: в БД/форме "0" | "1". */
export const isCrmBooleanFieldChecked = (value: unknown): boolean =>
  value === true ||
  value === 1 ||
  value === '1' ||
  value === 'true'

export const serializeCrmBooleanFieldValue = (checked: boolean): string =>
  checked ? '1' : '0'

/** Файловое поле: в значении только положительный user_file_id. */
export const parseCrmFileFieldValue = (value: unknown): number | null => {
  if (value == null || value === '') return null
  const id = Number(value)
  if (!Number.isFinite(id) || id <= 0) return null
  return id
}

export const serializeCrmFileFieldValue = (id: number | null): string =>
  id != null && id > 0 ? String(id) : ''

/** Подпись файла для таблицы / бейджа: file_name, иначе fallback по id. */
export const formatCrmFileFieldDisplayName = (params: {
  value?: unknown
  fileName?: string | null
}): string | null => {
  const trimmedName =
    typeof params.fileName === 'string' ? params.fileName.trim() : ''
  if (trimmedName) return trimmedName
  const fileId = parseCrmFileFieldValue(params.value)
  if (fileId != null) return `Файл #${fileId}`
  return null
}
export const normalizeCrmLeadFormFieldValue = (
  type: string | undefined,
  value: unknown,
): string => {
  if (type === 'boolean') {
    return serializeCrmBooleanFieldValue(isCrmBooleanFieldChecked(value))
  }
  if (type === 'file') {
    return serializeCrmFileFieldValue(parseCrmFileFieldValue(value))
  }
  if (value == null) return ''
  return String(value)
}
